/**
 * Map Setup — PanelMapService 연결
 *
 * import { mapSetup } from '@/features/panel-planning/setups/mapSetup';
 * // component options:
 *   data() { return { ...mapSetup.data() }; },
 *   beforeDestroy() { mapSetup.beforeDestroy.call(this); },
 *   methods: { ...mapSetup.methods }
 */
import { createPanelMapService } from '../services/panelMapService';

export const mapSetup = {
  data() {
    const mapRendererFromStorage =
      typeof localStorage !== 'undefined' ? localStorage.getItem('PANEL_MAP_RENDERER') : null;
    return {
      mapHost: null,
      mapRenderer:
        mapRendererFromStorage === 'webgl' || mapRendererFromStorage === 'canvas'
          ? mapRendererFromStorage
          : 'canvas'
    };
  },

  beforeDestroy() {
    this.mapService?.destroy();
    this.mapService = null;
  },

  methods: {
    initMap(targetId) {
      const refs = this.mapService.initMap(targetId, this.mapRenderer);
      Object.assign(this, refs);
      this.mapHost = this.mapService.getMapHost();
    },

    initPanelMapPlugins(pluginList) {
      this.mapService.initPlugins(this, pluginList);
    },

    updateModifyTranslateFeatures(handlers = {}) {
      this.mapService.updateTranslate({
        groupSelection: this.groupSelection,
        moduleSelection: this.moduleSelection,
        modifyInteraction: this.modifyInteraction,
        translateInteraction: this.translateInteraction
      }, handlers);
    }
  }
};
